import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

const state = {
    sidebarShow: "responsive",
    sidebarMinimize: false,
    asideShow: false,
    darkMode: false,
    role: "ADMIN",
    userCount: 5,
    enableErrorModal: false,
    notificationList: [],
    importProgress: 0,
    statusFilter: 0,
    selectedClientList: [],
    tempSelectedPrimaryCategories: [],

    ap_po_date: {
        ap_start: null,
        ap_end: null,
        po_start: null,
        po_end: null,
        ap_note: "",
        po_note: "",
    },
};

export let storeData = Vue.observable({
    projectDataList: [],
    vendorDataList: [],
    customFieldsDataList: [],
    vendorData: {},
    vendorAllocationData: [],
    projectData: {},
    archivedProjectData: {},
    primeCategories: [],
    categories: [],
    subCategories: [],
    vendorCategoryAllocation: [],
    currentUserDetails: {},
    categoryWiseOpportunity: {},
    treeData: [],
    userAuthenticationList: [],
    count: 0,
    approveVendor: {},
    selected10Vendors: [],
    lastClientFilter: "",

    primeCategoryCount: 0,
    secondaryCategoryCount: 0,
    subCategoryCount: 0,
    clientList: [],
});

export const getStoreFromLocalStorage = () => {
    if (localStorage.getItem("store")) {
        storeData = JSON.parse(localStorage.getItem("store"));
    }
    setTimeout(() => {
        localStorage.removeItem("store");
    }, 1500);
};

export const getSelectedClients = () => {
    // Check if the user is a sys_admin or group_admin
    if (storeData.currentUserDetails.role.name === "sys_admin" || storeData.currentUserDetails.role.name === "group_admin") {

        // If no clients are selected, return all clients excluding "All"
        if (state.selectedClientList.length === 0) {
            return storeData.clientList
                .filter((el) => el.label !== "All")  // Remove "All" clients
                .map((el) => el.value);  // Return only the client values
        }
        // If clients are selected, return only those selected
        else {
            return state.selectedClientList
                .filter((el) => el.label !== "All")  // Ensure "All" is not selected
                .map((el) => el.value);  // Return only the selected client values
        }
    }

    // For non-admin users, return their own client_id
    return [storeData.currentUserDetails.client_id];
};


const mutations = {
    toggleSidebarDesktop(state) {
        const sidebarOpened = [true, "responsive"].includes(state.sidebarShow);
        state.sidebarShow = sidebarOpened ? false : "responsive";
    },

    setStatusFilter(state, newStatus) {
        state.statusFilter = newStatus;
    },

    setAp_PO_Date(state, data) {
        state.ap_po_date = {
            ap_start: data.ap_start,
            ap_end: data.ap_end,
            po_start: data.po_start,
            po_end: data.po_end,
            ap_note: data.ap_note,
            po_note: data.po_note,
        };
    },
    toggleSidebarMobile(state) {
        const sidebarClosed = [false, "responsive"].includes(state.sidebarShow);
        state.sidebarShow = sidebarClosed ? true : "responsive";
    },
    set(state, [variable, value]) {
        state[variable] = value;
    },
    toggle(state, variable) {
        state[variable] = !state[variable];
    },
    removeNotification(state, notification) {
        state.notificationList.splice(
            state.notificationList.indexOf(notification),
            1
        );
    },
};

const actions = {};
export function assignCategories(categoryFromDb, checked) {
    let destinationVar = [];
    for (const el of categoryFromDb) {
        // If sys admin
        if (storeData.currentUserDetails.role.name === "sys_admin") {
            el.name = el.alias;
        } else {
            if (
                el?.overrided_prime_categories &&
                el?.overrided_prime_categories.length > 0
            ) {
                el.name = el.overrided_prime_categories[0].overrided_name;
                el.overridedId = el.overrided_prime_categories[0].id;
            } else if (
                el?.overrided_secondary_categories &&
                el?.overrided_secondary_categories.length > 0
            ) {
                el.name = el.overrided_secondary_categories[0].overrided_name;
                el.overridedId = el.overrided_secondary_categories[0].id;
            } else if (
                el?.overrided_sub_categories &&
                el?.overrided_sub_categories.length > 0
            ) {
                el.name = el.overrided_sub_categories[0].overrided_name;
                el.overridedId = el.overrided_sub_categories[0].id;
            } else {
                el.name = el.alias;
                el.overrided = null;
            }
        }

        delete el.alias;
        el.checked = checked;
        destinationVar.push(el);
    }
    return destinationVar;
}

export default new Vuex.Store({
    state,
    mutations,
});
